module.exports = __webpack_public_path__ + "img/HOCL.1adc5c3f.svg";